import { useLayoutEffect, useMemo, useRef, useState } from "react";

export type CursorTooltipState = {
  open: boolean;
  text: string;
  x: number;
  y: number;
};

export function CursorTooltip({ state }: { state: CursorTooltipState }) {
  const ref = useRef<HTMLDivElement | null>(null);
  const [size, setSize] = useState({ w: 0, h: 0 });

  useLayoutEffect(() => {
    if (!ref.current) return;
    const r = ref.current.getBoundingClientRect();
    setSize({ w: r.width, h: r.height });
  }, [state.text, state.open]);

  const pos = useMemo(() => {
    const pad = 12;
    const offsetY = 26;
    const vw = window.innerWidth;
    const vh = window.innerHeight;

    let left = state.x - size.w / 2;
    let top = state.y + offsetY;

    // Clamp within viewport
    left = Math.max(pad, Math.min(vw - size.w - pad, left));
    top = Math.max(pad, Math.min(vh - size.h - pad, top));

    return { left, top };
  }, [size.h, size.w, state.x, state.y]);

  return (
    <div
      className={`cursorTip ${state.open ? "cursorTipOpen" : ""}`}
      style={{ left: pos.left, top: pos.top }}
      aria-hidden="true"
    >
      <div ref={ref} className="cursorTipInner">
        {state.text}
      </div>
    </div>
  );
}
